import useAxios from './hooks/useAxios';

const ReleatedLinks = () => {
    const { data: relatedLinksContent} = useAxios(process.env.REACT_APP_GCDEV_API_DEMO_RELATEDLINKS);
    if(relatedLinksContent){
        return(relatedLinksContent);
    }else {
        return [];
    }
}
export default ReleatedLinks;